/** Portuguese Entrepreneurship Support Translations */
export const entrepreneurship = {
  entrepreneurship: {
    pageTitle: "Dimensão Apoio ao Empreendedorismo",
    weightInFII: "peso no FII",
    heroSubtitle: "Capacitando Jovens para Criar Empregos Sustentáveis e Construir Riqueza (18-40 anos)",
    quote: "$1,7 trilhão é a lacuna global de financiamento para pequenas e médias empresas. No entanto, na África Subsaariana, 28% dos jovens buscam ativamente o empreendedorismo—2,3x a média global. A lacuna não é ambição. É acesso.",
    fiiWeightDistribution: "Distribuição de Peso do FII",
    mentalHealth: "Saúde Mental",
    workforceLabel: "Força de Trabalho",
    entrepreneurshipLabel: "Empreendedorismo",
    understandOpportunity: "Entender a oportunidade",
    opportunityTitle: "A Oportunidade de Empreendedorismo em Números",
    opportunitySubtitle: "Estatísticas críticas que moldam o empreendedorismo juvenil global",
    opportunity: {
      stat1Label: "lacuna global de financiamento de PMEs",
      stat2Label: "taxa TEA juvenil na África Subsaariana (2,3x média global)",
      stat3Label: "aspiração média global de empreendedorismo",
      stat4Label: "financiamento VC para empreendedoras mulheres",
      stat5Label: "total de financiamento VC para mulheres globalmente",
      stat6Label: "novas startups lançadas anualmente",
      stat7Label: "taxa de falência de startups em 5 anos",
      stat8Label: "empregos criados por 1% de aumento no empreendedorismo",
    },
    severity: {
      barrier: "Barreira",
      opportunity: "Oportunidade",
      gap: "Lacuna",
    },
    coreProblem: "O Problema Central",
    coreProblemDesc: "NÃO é falta de ambição. O empreendedorismo é o mecanismo primário de sobrevivência em economias com emprego tradicional limitado. Na África/OM, 52% dos jovens querem iniciar negócios—não é um luxo; é a economia do futuro. As barreiras reais: Lacuna de capital ($1,7T globalmente), Lacuna de habilidades (planejamento de negócios, literacia financeira), Lacuna de confiança (credores não confiam em jovens empreendedores), Lacuna de infraestrutura (carga regulatória, sistemas de pagamento), e Lacuna de gênero (mulheres enfrentam 2-3x mais barreiras).",
    fiiTitle: "Metodologia FII de Empreendedorismo",
    fiiSubtitle: "Pontuação de Empreendedorismo = 25% do Índice de Impacto Futuro",
    subWeight: "sub-peso",
    globalAverage: "Média global",
    highest: "Mais alto",
    lowest: "Mais baixo",
    fii: {
      easeOfBusiness: "Facilidade de Fazer Negócios",
      easeOfBusinessDef: "Ambiente regulatório, atrito para startups, registro de empresas",
      easeHighest: "Singapura, Nova Zelândia (90+)",
      easeLowest: "Venezuela, Somália (40-)",
      accessFinancing: "Acesso a Financiamento",
      accessFinancingDef: "Disponibilidade de capital, acesso a crédito, VC, investimento anjo",
      accessHighest: "EUA, Reino Unido (80%+ da população)",
      accessLowest: "África Subsaariana (10-20%)",
      tea: "Empreendedorismo em Estágio Inicial (TEA)",
      teaDef: "% da população iniciando/gerenciando novos negócios ativamente",
      teaHighest: "África Subsaariana (28%)",
      teaLowest: "Europa (12%)",
      digitalInfra: "Infraestrutura Digital",
      digitalInfraDef: "Internet, sistemas de pagamento, prontidão para e-commerce",
      digitalHighest: "Países nórdicos (95%)",
      digitalLowest: "África Subsaariana (20-30%)",
    },
    regionalTitle: "Pontuações Regionais de Empreendedorismo",
    regionalSubtitle: "Dimensão FII de Empreendedorismo: Desempenho Regional",
    regions: {
      europe: "Europa",
      asiaPacific: "Ásia e o Pacífico",
      americas: "América",
      africaMe: "África e Oriente Médio",
    },
    status: {
      strong: "Forte",
      growing: "Crescendo",
      mixed: "Misto",
      emerging: "Emergente",
    },
    regional: {
      europeDrivers: "Suporte regulatório, acesso a capital, incubadoras",
      europeOpportunity: "Cultura avessa a risco precisa de aceleração de inovação",
      asiaPacificDrivers: "Ecossistema de unicórnios, apoio governamental, hubs de tecnologia",
      asiaPacificOpportunity: "Cidades tier-2/3 precisam de acesso a capital",
      americasDrivers: "América do Norte forte (80+), cultura de inovação",
      americasOpportunity: "América Latina precisa de democratização de capital",
      africaMeDrivers: "Maior aspiração (52%), salto digital",
      africaMeOpportunity: "Fechamento de lacuna de capital severa, conexão com MFI",
    },
    strength: "Força",
    challenge: "Oportunidade",
    easeScore: "Pontuação de Facilidade",
    financingScore: "Financiamento",
    teaScore: "Taxa TEA",
    digitalScore: "Digital",
    keyFinding: "Descoberta Principal",
    keyFindingDesc: "As pontuações de empreendedorismo variam apenas 12 pontos (Europa 72 vs. África/OM 60) — a MENOR lacuna FII. No entanto, a aspiração ao empreendedorismo é MAIOR na África/OM (52% vs. 35% global). Isso significa que a capacidade existe; apenas a infraestrutura está faltando.",
    projectionTitle: "Projeção 2024 vs 2040",
    financingTitle: "A Lacuna de Financiamento de $1,7 Trilhão",
    financingSubtitle: "Onde a lacuna global de financiamento de PMEs se origina e como a JCI pode ajudar a fechá-la",
    gapByRegion: "Lacuna de Financiamento por Região",
    trillion: "Trilhão",
    totalGap: "Lacuna Total de Financiamento Global de PMEs",
    timeline: "Prazo",
    impact: "Impacto",
    financingGapTitle: "A Lacuna de Financiamento de $1,7 Trilhão",
    financingGapSubtitle: "Onde a lacuna global de financiamento de PMEs se origina",
    financingGap: {
      subSaharan: "África Subsaariana",
      subSaharanGap: "$500B+",
      subSaharanCause: "Sem infraestrutura formal de crédito, alta percepção de risco",
      southAsia: "Sul da Ásia",
      southAsiaGap: "$400B+",
      southAsiaCause: "Barreiras regulatórias, dominância da economia informal",
      southeastAsia: "Sudeste Asiático",
      southeastAsiaGap: "$200B+",
      southeastAsiaCause: "Inconsistência regulatória, concentração de VC",
      latinAmerica: "América Latina",
      latinAmericaGap: "$300B+",
      latinAmericaCause: "Volatilidade econômica, carga regulatória",
      mena: "Oriente Médio/Norte da África",
      menaGap: "$200B+",
      menaCause: "Mercados de capital limitados, discriminação de gênero",
    },
    gapMeaning: "O Que 'Lacuna de Financiamento' Realmente Significa",
    gapTypes: {
      awareness: "Lacuna de Conscientização",
      awarenessDef: "Empreendedores não sabem que fontes de financiamento existem",
      access: "Lacuna de Acesso",
      accessDef: "Capital concentrado geograficamente + demograficamente",
      skills: "Lacuna de Habilidades",
      skillsDef: "Não conseguem escrever propostas ou projeções financeiras",
      trust: "Lacuna de Confiança",
      trustDef: "Credores não confiam em jovens empreendedores",
      collateral: "Lacuna de Garantia",
      collateralDef: "Jovens pobres não têm ativos para oferecer",
      gender: "Lacuna de Gênero",
      genderDef: "Mulheres enfrentam 2-3x mais barreiras institucionais",
    },
    landscapeTitle: "Panorama Global do Empreendedorismo",
    landscapeSubtitle: "Métricas de empreendedorismo por região (GEM 2024-25)",
    teaRate: "Taxa TEA",
    businessTypes: "Tipos de Negócios",
    financing: "Financiamento",
    successRate: "Taxa de Sucesso",
    landscape: {
      subSaharanTitle: "África Subsaariana",
      subSaharanTea: "28% TEA (MAIOR globalmente)",
      subSaharanTypes: "70% micro, 25% PMEs, 5% escaláveis",
      subSaharanFinancing: "80% autofinanciado/família; 5% formal",
      subSaharanSuccess: "40% taxa de sobrevivência",
      southeastAsiaTitle: "Sudeste Asiático",
      southeastAsiaTea: "20% TEA (forte, crescendo)",
      southeastAsiaTypes: "40% digital, 35% varejo, 25% manufatura",
      southeastAsiaFinancing: "50% bootstrap, 30% anjo/VC",
      southeastAsiaSuccess: "55% taxa de sobrevivência",
      latinAmericaTitle: "América Latina",
      latinAmericaTea: "18% TEA (crescendo)",
      latinAmericaTypes: "60% micro, 30% PMEs, 10% escaláveis",
      latinAmericaFinancing: "70% autofinanciado, 20% família",
      latinAmericaSuccess: "45% taxa de sobrevivência",
      europeTitle: "Europa",
      europeTea: "12% TEA (maduro, estável)",
      europeTypes: "20% micro, 30% PMEs, 50% escaláveis",
      europeFinancing: "60% institucional, 40% autofinanciado",
      europeSuccess: "65% taxa de sobrevivência",
      northAmericaTitle: "América do Norte",
      northAmericaTea: "15% TEA (liderado por inovação)",
      northAmericaTypes: "10% micro, 20% PMEs, 70% escaláveis",
      northAmericaFinancing: "50% VC/anjo, 30% institucional",
      northAmericaSuccess: "70% taxa de sobrevivência",
    },
    deepDiveTitle: "Análises Regionais Detalhadas",
    deepDiveSubtitle: "Análise aprofundada de empreendedorismo por região JCI",
    strengths: "Pontos Fortes",
    challenges: "Desafios",
    jciOpportunity: "Oportunidade JCI",
    deepDive: {
      europe: {
        strength1: "Infraestrutura de classe mundial (clareza regulatória, sistemas digitais)",
        strength2: "Acesso a capital: €80B+ investidos em 2024",
        strength3: "Ecossistema maduro de startups: incubadoras, aceleradoras",
        challenge1: "Aversão a risco: falha estigmatizada",
        challenge2: "Fuga de cérebros para EUA/Ásia",
        challenge3: "Concentração de capital em Londres, Berlim, Paris",
        opportunity: "Foco em aceleração de inovação, startups de deep tech",
      },
      asiaPacific: {
        strength1: "Ecossistema de unicórnios: China 200+, Índia 80+",
        strength2: "Aceleração governamental: bilhões investidos",
        strength3: "Dividendo demográfico: 35% abaixo de 25 anos",
        challenge1: "Desigualdade extrema: riqueza em cidades tier-1",
        challenge2: "Volatilidade regulatória",
        challenge3: "Barreiras de gênero: culturais + institucionais",
        opportunity: "Iniciativa de startups tier-2/3, programas de mulheres em tech",
      },
      americas: {
        strength1: "Maior mercado de VC ($150B+ investidos em 2024)",
        strength2: "Cultura de inovação: Silicon Valley, NYC, Toronto",
        strength3: "Mercados diversos: tech, biotech, fintech",
        challenge1: "Divisão Norte-Sul de 14 pontos",
        challenge2: "Carga regulatória da América Latina",
        challenge3: "Apenas 2% das startups LAC recebem VC",
        opportunity: "Ponte Norte-Sul para mentoria, capacidade LAC",
      },
      africaMe: {
        strength1: "Maior aspiração globalmente: 52% querem negócio",
        strength2: "População jovem: 60% abaixo de 25 anos",
        strength3: "Salto digital: mobile-first (95%+ têm telefones)",
        challenge1: "Lacuna de financiamento MASSIVA: 80% autofinanciado",
        challenge2: "Lacunas de habilidades: planejamento de negócios, contabilidade",
        challenge3: "Meninas sistematicamente excluídas",
        opportunity: "Oportunidade de $10T: alcançar 5% de 1,2B jovens → 6M empregos",
      },
    },
    outcomesTitle: "Resultados e Estudos de Caso",
    outcomesSubtitle: "Impacto mensurável dos programas CYE e empreendedorismo da JCI",
    cases: {
      hongKongCountry: "Hong Kong",
      hongKongTitle: "JAPJAP Zero Waste Limited",
      hongKongOutcome: "Resíduo alimentar → proteína + composto usando tecnologia AI-IoT. Fundadora mulher, origem imigrante.",
      hongKongMetric: "100+ toneladas processadas",
      panamaCountry: "Panamá",
      panamaTitle: "Integra Project Management",
      panamaOutcome: "Eficiência da cadeia de suprimentos alimentares para América Latina. 30 novos produtos, 97% taxa de qualidade.",
      panamaMetric: "250 toneladas CO2 reduzidas",
      turkeyCountry: "Turquia",
      turkeyTitle: "Grinove Materials",
      turkeyOutcome: "Resíduo agrícola → biomateriais compostáveis. Cientista mulher virou empreendedora.",
      turkeyMetric: "Expansão europeia planejada",
    },
    actionsTitle: "Ações Recomendadas para JCI",
    actionsSubtitle: "Prioridades estratégicas para fechar a lacuna de empreendedorismo",
    actions: {
      action1Title: "Escalar CYE 10x",
      action1Desc: "Expandir de 108 para 1.000 empreendedores/ano, alcançando 5.000 até 2030",
      action1Effort: "18-24 meses",
      action1Impact: "10x alcance",
      action2Title: "Fundo de Empreendedorismo Feminino",
      action2Desc: "Criar fundo de $100M para fundadoras com microfinanças + mentoria",
      action2Effort: "18 meses",
      action2Impact: "50K mulheres até 2030",
      action3Title: "Parcerias com MFI",
      action3Desc: "Formalizar parcerias com 50 instituições de microfinanças",
      action3Effort: "12 meses",
      action3Impact: "500K acesso a crédito",
      action4Title: "Hubs de Incubação JCI",
      action4Desc: "Construir 30 hubs de incubação na África/Ásia/ALC",
      action4Effort: "24 meses",
      action4Impact: "10K acelerados",
      action5Title: "Marketplace de Startups",
      action5Desc: "Criar plataforma digital conectando empreendedores com fornecedores, clientes, mentores",
      action5Effort: "9-12 meses",
      action5Impact: "100K+ conectados",
      action6Title: "Redes Regionais JIB",
      action6Desc: "Estabelecer redes de mentoria conectando 5.000+ mentores com fundadores",
      action6Effort: "12 meses",
      action6Impact: "5K+ mentores",
    },
    ctaTitle: "Empreendedorismo Cria Empregos",
    ctaDescription: "Quando o emprego tradicional é escasso, o empreendedorismo se torna o PRINCIPAL caminho para oportunidade. 1 empreendedor cria 3-5 empregos. Se a JCI escalar 10x até 2030: 5M empregos criados, $500B+ em valor de negócios globalmente.",
    exploreFII: "Explorar FII",
    exploreWorkforce: "Explorar Força de Trabalho",
    dataSources: { title: "Fontes de Dados" },
  },
} as const;

export type EntrepreneurshipTranslations = typeof entrepreneurship;
